<template>
  <el-form ref="ruleFormRef" :model="ruleForm" :inline="true" :rules="rules" label-width="100px" class="demo-ruleForm"
           status-icon>
    <el-form-item label="是否住宿" prop="accommodation">
      <el-select v-model="ruleForm.accommodation" placeholder="是否住宿">
        <el-option v-for="item in accommodationOptions" :key="item.value" :label="item.label"
                   :value="item.value" />
      </el-select>
    </el-form-item>
    <el-form-item label="变动日期" prop="accommodationDate">
      <el-date-picker v-model="ruleForm.accommodationDate" type="month" format="YYYY-MM"
                      value-format="YYYY.MM.DD" placeholder="住宿变动生效日期" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" class="main-btn main-btn-primary" @click="submitForm(ruleFormRef)">
        保存
      </el-button>
    </el-form-item>
  </el-form>
  <el-table header-row-class-name="main-table-header" :data="tableData" border height="670">
    <el-table-column label="是否住宿" min-width="100" align="center" prop="status">
      <template #default="scope">
        <span>{{scope.row.status == 1 ? '是' : '否'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="起始日期" min-width="130" align="center" prop="startDate"></el-table-column>
    <el-table-column label="结束日期" min-width="130" align="center" prop="endDate"></el-table-column>
    <el-table-column fixed="right" label="操作" width="230" align="center">
      <template #default="scope">
        <el-button type="danger" size="small" @click="deleteRow(scope.$index)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import {
  reactive,
  ref,
  onMounted,
  defineProps,
  defineEmits,
  watch
} from "vue";
import {
  fetchAccommodationChangeList as fetchChangeList,
  delAccommodationChange as delChange
} from "@/api/personChange";
import {ElMessage, ElMessageBox} from "element-plus";

const tableData = ref([]);

const getList = () => {
  fetchChangeList({personId: ruleForm.value.id}).then((res) => {
    tableData.value = res.data;
  });
};

const deleteRow = (index) => {
  ElMessageBox.confirm("确定要删除此行信息吗?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
      .then(() => {
        delChange({
          id: tableData.value[index].id,
        }).then(() => {
          emit('onChange');
          getList();
          ElMessage({
            type: "success",
            message: "删除成功！",
          });
        });
      })
      .catch(() => {
      });
};

const ruleFormRef = ref();
const ruleForm = ref({});

const props = defineProps(['info'])
watch(props, (newVal, oldVal) => {
  if (newVal.info) {
    ruleForm.value = JSON.parse(JSON.stringify(newVal.info))
    getList()
  }
}, {immediate: true, deep: true})

onMounted(() => {
  getList();
});

const accommodationOptions = ref([
  {
    value: 1,
    label: "是"
  },
  {
    value: 0,
    label: "否"
  }
])

const rules = reactive({});
const emit = defineEmits(['onSave'])
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      emit('onSave', ruleForm.value)
      console.log("submit!");
    } else {
      console.log("error submit!", fields);
    }
  });
};
</script>
<style lang="scss" scoped>
.el-form {
  // max-height: 65vh;
  // overflow-y: auto;
}

::v-deep .el-form-item__label {
  align-items: center;
  line-height: 16px;
  padding: 0 12px 0 4px;
  text-align: right;
}
</style>
